import React, { useEffect, useState} from "react";
import Select from "react-select";
import {useForm} from "react-hook-form";
import StepHeader from "./stepParts/StepHeader";
import {
  currencyToNumber,
  rewriteRadioOptionsClasses,
  stepStates,
  getCalculatorType,
  CALCULATOR_TYPES,
  numberToCurrency, checkMobileBrowser,
} from "../../services/helpers";
import Input from "../core/Input";
import {gtm} from "../../services/gtm";
import {useSelector} from "react-redux";
import StepHouseOptions from "./stepParts/StepHouseOptions";
import {getStep3HeaderSummary, getStepParams} from "../../services/stepHelpers";
import NextButton from "./stepParts/NextButton";
import {getMortgageProviderAction} from "../../store/actions/calculatorActions";
import {assetsBaseUrl} from "../../services/calculationsApi";
import ReactTooltip from "react-tooltip";
import {RadioGroup, ReversedRadioButton} from "react-radio-buttons";
import {FormattedMessage, useIntl} from "react-intl";

function Step3({
                 stepNumber,
                 state,
                 loading,
                 openStep,
                 onStepSubmit,
                 dispatch,
                 shouldReset,
                 setResetForms,
               }) {
  const intl = useIntl();
  const [params] = useState(getStepParams());
  const { EnergyLabel } = useSelector((state) => state.calculator);
  const [calculatorType, setCalculatorType] = useState();
  const [stepHeaderSummary, setStepHeaderSummary] = useState();
  const [IsNieuwbouw, setIsNieuwbouw] = useState();
  const [sustainabilityUplift, setSustainabilityUplift] = useState(params?.SustainabilityUplift ? params.SustainabilityUplift.toString() : `0`);
  const [AmountAboveNhg, setAmountAboveNhg] = useState(false);
  const [energyLabel, setEnergyLabel] = useState(EnergyLabel?.value ? EnergyLabel : {value: "", label: intl.formatMessage({ id: 'step3.whatIsEnergyLabel.NoLabel' , defaultMessage: 'Geen Label'})});

  const {
    HasPartner,
    IsNieuwbouw: StateIsNieuwbouw,
    SelectedMortgageProvider,
    Nhg
  } = useSelector((state) => state.calculator);
  const getDefaultValues = (params) => {
    return {
      Woning: numberToCurrency(params?.Woning, true),
    }
  }

  const options = [
    {value: "APPPP", label: intl.formatMessage({ id: 'step3.whatIsEnergyLabel.Egp' , defaultMessage: 'A++++ incl. energieprestatiegarantie'})},
    {value: "APPPP", label: "A++++"},
    {value: "APPP", label: "A+++"},
    {value: "APP", label: "A++"},
    {value: "AP", label: "A+"},
    {value: "A", label: "A"},
    {value: "B", label: "B"},
    {value: "C", label: "C"},
    {value: "D", label: "D"},
    {value: "E", label: "E"},
    {value: "F", label: "F"},
    {value: "G", label: "G"},
    {value: "", label: intl.formatMessage({ id: 'step3.whatIsEnergyLabel.NoLabel' , defaultMessage: 'Geen Label'})}
  ];

  const {register, handleSubmit, formState, errors, reset, watch} = useForm({
    mode: "onChange",
    defaultValues: getDefaultValues(params),
  });

  const watchWoning = watch("Woning");

  useEffect(() => {
    const handleMobileFocus = () => {
      if (checkMobileBrowser(navigator.userAgent || navigator.vendor || window.opera)) {
        document.activeElement.scrollIntoView(true);
      }
    };

    document.addEventListener("focus", handleMobileFocus, true);
    return document.removeEventListener("focus", handleMobileFocus);
  }, []);


  useEffect(() => {
    if (params) {
      setStepHeaderSummary(
      getStep3HeaderSummary(currencyToNumber(params?.Woning), intl)
      );
    }
  }, [params, intl]);

  useEffect(() => {
    if (shouldReset) {
      reset(getDefaultValues({}));
      setStepHeaderSummary("");
      setResetForms(false);
    }
  }, [shouldReset, reset, setResetForms]);

  useEffect(() => {
    const housePrice = currencyToNumber(watchWoning);
    if (typeof SelectedMortgageProvider === "object" && SelectedMortgageProvider?.initial?.isNhg) {

      const lookupId = housePrice > Nhg.existingBuilding ? SelectedMortgageProvider?.initial?.nonNhgLookupId : SelectedMortgageProvider?.initial?.nhglookupId;
      const amountAboveNhg = housePrice > Nhg.existingBuilding;

      if (lookupId !== SelectedMortgageProvider.lookupId) {
        dispatch(getMortgageProviderAction(lookupId, (params?.isnewbuilding) ? params?.isnewbuilding : false))
        setAmountAboveNhg(amountAboveNhg)
      }
    }
  }, [dispatch, watchWoning, SelectedMortgageProvider, setAmountAboveNhg, Nhg, params]);

  useEffect(() => {
    setCalculatorType(getCalculatorType());
    (StateIsNieuwbouw) ? setIsNieuwbouw(StateIsNieuwbouw.toString()) : setIsNieuwbouw(getCalculatorType() === CALCULATOR_TYPES.hoeveelKanIkLenen ? "0" : "1");
  }, [calculatorType, StateIsNieuwbouw]);

  rewriteRadioOptionsClasses("already-found-a-house", [
    "no",
    "yes-existing",
    "yes-new",
  ]);

  const onHouseOptionsChange = (value) => {
    setIsNieuwbouw(value);
  };

  const onSustainabilityUpliftChange = (value) => {
    setSustainabilityUplift(value);
  }

  const onEnergyLabelChange = (value) => {
    setEnergyLabel(value)
  }

  const onSubmit = (data) => {
    data.Woning = currencyToNumber(data.Woning);
    data.IsNieuwbouw = parseInt(IsNieuwbouw);
    data.SustainabilityUplift = parseInt(sustainabilityUplift);
    data.EnergyLabel = energyLabel;
    setStepHeaderSummary(getStep3HeaderSummary(data.Woning, intl));

    if (IsNieuwbouw === "0" && calculatorType !==
    CALCULATOR_TYPES.watWordenMijnMaandLasten) {
      data.Woning = 0;
    }

    // general event
    const tagManagerArgs = {
      gtmId: "GTM-T78CX5",
      dataLayer: {
        event: "gtm.calculators",
        eventCategory: "Calculator",
        eventAction: "Woning",
        eventLabel:
        IsNieuwbouw === "0"
        ? "nog niet"
        : IsNieuwbouw === "1"
        ? "huis-bestaande bouw"
        : "huis-nieuwbouw",
      },
    };

    gtm(tagManagerArgs);

    onStepSubmit(data, stepNumber);
  };

  const isFormValid = formState.isValid && IsNieuwbouw;

  return (
  <div
  className={`ct-step ${
  state === stepStates.inactive && "ct-step__inactive"
  }
                                 ${
  state === stepStates.filled &&
  "ct-step__filled"
  }
                                 ${
  state === stepStates.closed &&
  "ct-step__closed"
  }`}
  >
    <StepHeader
    title={`${
    calculatorType === CALCULATOR_TYPES.watWordenMijnMaandLasten
    ? intl.formatMessage({ id: 'step3.headerTitle.watWordenMijnMaandLasten', defaultMessage: 'Hypotheek' })
    : intl.formatMessage({ id: 'step3.headerTitle.default', defaultMessage: 'Woning' })
    }`}
    stepSummary={stepHeaderSummary}
    stepNumber={stepNumber}
    stepState={state}
    openStep={openStep}
    onClose={handleSubmit(onSubmit)}
    />

    <div
    className={`ct-step__body ${
    state === stepStates.active ? "ct-step__body-opened" : null
    }`}
    >
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div>
          <div className="ct-step__body-primary-question">

            {(calculatorType === CALCULATOR_TYPES.watWordenMijnMaandLasten || calculatorType === CALCULATOR_TYPES.kanIkDitHuisBetalen) && (
            <FormattedMessage id="step3.wantToBuyAHouse" defaultMessage="{question}"
                              values={{
                                question: calculatorType === CALCULATOR_TYPES.watWordenMijnMaandLasten ?
                                intl.formatMessage({ id: 'step3.wantToBuyAHouse.watWordenMijnMaandLasten', defaultMessage: 'Wat worden mijn maandlasten?' }) :
                                intl.formatMessage({ id: 'step3.wantToBuyAHouse.kanIkDitHuisBetalen', defaultMessage: 'Kan ik dit huis betalen?' })
                                }}
            />
            )}

            {calculatorType === CALCULATOR_TYPES.hoeveelKanIkLenen && (
            <>
              <FormattedMessage
              id="step3.wantToBuyAHouse.hoeveelKanIkLenen"
              defaultMessage="{salutation} al een huis op het oog?*"
              values={{
                salutation: HasPartner ?
                intl.formatMessage({ id: 'step2.wantToBuyAHouse.hasPartner.yes', defaultMessage: 'Hebben jullie' }) :
                intl.formatMessage({ id: 'step2.wantToBuyAHouse.hasPartner.no', defaultMessage: 'Heb je' })
              }}
              />

              <img
                className="ct-step__tool-tip ct-step__tool-tip--align-middle"
                data-tip={intl.formatMessage({ id: 'step3.wantToBuyAHouse.hoeveelKanIkLenen.tooltip', defaultMessage: 'We vragen naar het type bouw om voor je uit te rekenen met hoeveel eigen inleg je rekening moet houden. Onder nieuwbouw verstaan we woningen die nog gebouwd moeten worden of nog in aanbouw zijn.'})}
                src={`${assetsBaseUrl}/assets/svg/info.svg`}
                alt=""
              />
              <ReactTooltip place={"right"} effect={"solid"} />
            </>
            )}
          </div>

          <div className="ct-step__body-secondary-subquestions">
            <div className="ct-step__body-subquestion">

                {calculatorType === CALCULATOR_TYPES.watWordenMijnMaandLasten &&
                <div className="ct-step__body-tip margin-bottom-10">
                <FormattedMessage id="step3.wantToBuyAHouse.watWordenMijnMaandLasten.tip"
                                  defaultMessage="We rekenen graag voor je uit wat de maandlasten zijn bij het gewenste hypotheekbedrag. Zo kun je makkelijk zien welk bedrag je elke maand kwijt bent aan hypotheeklasten."/>
                </div>
                }
                {calculatorType === CALCULATOR_TYPES.hoeveelKanIkLenen &&
                <div className="ct-step__body-tip">
                  <FormattedMessage id="step3.wantToBuyAHouse.hoeveelKanIkLenen.tip"
                                    defaultMessage="Bij het kopen van een woning komen extra kosten kijken die je als koper zelf moet financieren, de hoogte hiervan hangt af van de koopsom."/>

                  {calculatorType === CALCULATOR_TYPES.hoeveelKanIkLenen &&
                  StepHouseOptions.all(onHouseOptionsChange, IsNieuwbouw)
                  }
                </div>
                }

              {IsNieuwbouw !== "0" &&
              <>
                {calculatorType !== CALCULATOR_TYPES.watWordenMijnMaandLasten ?
                <FormattedMessage id="step3.housePrice.askingPrice"
                                  defaultMessage="Wat is de vraagprijs van deze woning?*"/>
                :
                <FormattedMessage id="step3.housePrice.mortgageAmount"
                                defaultMessage="Wat is het hypotheekbedrag?*"/>
                }

                <Input
                placeholder="€"
                type="currency"
                register={register}
                validationRules={{
                  required: true,
                  min: 1,
                }}
                error={errors.Woning}
                name="Woning"
                errorTitle={intl.formatMessage({id: 'step3.housePrice.label', defaultMessage: 'koopsom'})}
                />
              </>
              }
            </div>
          </div>

          {calculatorType === CALCULATOR_TYPES.kanIkDitHuisBetalen &&
          <>
            <div className="ct-step__body-tip">
              <FormattedMessage id="step3.housePrice.houseType" defaultMessage="Is het huis dat je op het oog hebt een bestaande woning of nieuwbouwwoning?*" />
              <img
              className="ct-step__tool-tip"
              data-tip={intl.formatMessage({ id: 'step3.housePrice.houseType.tooltip', defaultMessage: 'We vragen naar het type bouw om voor je uit te rekenen met hoeveel eigen inleg je rekening moet houden. Onder nieuwbouw verstaan we woningen die nog gebouwd moeten worden of nog in aanbouw zijn.'})}
              src={`${assetsBaseUrl}/assets/svg/info.svg`}
              alt=""
              />
              <ReactTooltip
              place={"right"}
              effect={"solid"}
              />
            </div>
            {StepHouseOptions.partial(onHouseOptionsChange, IsNieuwbouw)}
          </>
          }


          {(calculatorType === CALCULATOR_TYPES.hoeveelKanIkLenen || calculatorType === CALCULATOR_TYPES.kanIkDitHuisBetalen) && IsNieuwbouw !== "0" &&
          <div className="ct-step__body-secondary-subquestions">
            <div className="ct-step__body-subquestion">
              <FormattedMessage id="step3.makeHousSustainable" defaultMessage="Wil je deze woning verduurzamen?" />
            </div>
            <RadioGroup
            onChange={onSustainabilityUpliftChange}
            value={sustainabilityUplift}
            className="ct-step__radio-group ct-step__radio-group-vertical already-found-a-house"
            >
              <ReversedRadioButton
              value={`1`}
              rootColor="#000000"
              pointColor="#000000"
              iconInnerSize={18}
              iconSize={18}
              >
                <FormattedMessage id="step3.makeHousSustainable.yes" defaultMessage="Ja" />
              </ReversedRadioButton>

              <ReversedRadioButton
              value={`0`}
              rootColor="#000000"
              pointColor="#000000"
              iconInnerSize={18}
              iconSize={18}
              >
                <FormattedMessage id="step3.makeHousSustainable.no" defaultMessage="Nee" />
              </ReversedRadioButton>
            </RadioGroup>
            <div className="ct-step__body-subquestion">
              <FormattedMessage id="step3.whatIsEnergyLabel.no" defaultMessage="Wat is het (voorlopig) energielabel van deze woning?" />

            </div>
            <div className="ct-step__energy-label">
              <Select
              value={energyLabel}
              onChange={onEnergyLabelChange}
              options={options}
              />
            </div>
          </div>
          }
        </div>


        {AmountAboveNhg && getCalculatorType() === CALCULATOR_TYPES.watWordenMijnMaandLasten && (
          <div className="ct-input_error-msg margin-bottom-70">
            <FormattedMessage
            id="nhgError"
            defaultMessage="Je hebt gekozen voor een rente met Nationale Hypotheekgarantie (NHG). NHG is een garantie op hypotheken tot {existingBuilding} euro. Het gewenste hypotheekbedrag is hoger dan {existingBuilding} euro. Om een goede berekening te kunnen doen, hebben wij de laagste hypotheekrente zonder NHG (100% marktwaarde) gebruikt."
            values={{existingBuilding: Nhg.existingBuilding}}
            />
          </div>
        )}
        <NextButton
        loading={loading}
        isFormValid={isFormValid}
        formState={formState}
        ></NextButton>
      </form>
    </div>
  </div>
  );
}

export default Step3;
